export default __webpack_public_path__ + "static/media/editHover.ab53b147.svg";